const EVENTS = [
  ["gb", "Trader from UK passed Phase 1 — $100K Challenge"],
  ["sg", "Trader from Singapore requested $1,950 payout"],
  ["de", "Trader from Germany joined Discord mentorship"],
  ["us", "Trader from USA requested $5,400 payout"],
  ["ae", "Trader from UAE passed Phase 2 — $50K Challenge"],
  ["au", "Trader from Australia funded instantly — $25K account"],
  ["ca", "Trader from Canada requested $3,200 payout"],
  ["in", "Trader from India scaled up to $200K capital"],
  ["za", "Trader from South Africa passed Phase 1 — $10K Challenge"],
  ["nl", "Trader from Netherlands payout approved — $6,480"],
];

const Flag = ({ code }) => (
  <img
    src={`https://flagcdn.com/w40/${code}.png`}
    alt=""
    loading="lazy"
    className="w-5 h-[15px] rounded-[3px] object-cover shrink-0 ring-1 ring-white/15"
  />
);

export default function Ticker() {
  const row = [...EVENTS, ...EVENTS];
  return (
    <div
      data-testid="live-activity-ticker"
      className="relative border-y border-white/5 bg-[#030B16]/60 py-3.5 overflow-hidden"
    >
      <div className="absolute left-0 inset-y-0 w-24 bg-gradient-to-r from-[#0D0E13] to-transparent z-10" />
      <div className="absolute right-0 inset-y-0 w-24 bg-gradient-to-l from-[#0D0E13] to-transparent z-10" />
      <div className="marquee-track gap-10">
        {row.map(([code, e], i) => (
          <div key={i} className="flex items-center gap-10 shrink-0">
            <span className="flex items-center gap-2.5 text-sm text-[#DBDFE8] whitespace-nowrap">
              <Flag code={code} />
              {e}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#FFD700] shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
}
